import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorPage, type ErrorPageNavigation } from './error-page';

type PageErrorBoundaryProps = {
  children: ReactNode;
  variant?: 'in-layout' | 'standalone';
  errorNavigation?: ErrorPageNavigation;
};

export function PageErrorBoundary({
  children,
  variant = 'in-layout',
  errorNavigation,
}: PageErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ eventId, resetError }) => (
        <ErrorPage
          eventId={eventId}
          resetError={resetError}
          variant={variant}
          errorNavigation={errorNavigation}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
